// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#pdfReader{
    margin-top: 0px;
    height: calc(100% - 20px);
    width: 100vw;
}
.pdfViewer{
    height: 100%;
}
.pdfViewer--hidden{
    display: none;
}
`, "",{"version":3,"sources":["webpack://./../mirage/src/components/PdfReader/PdfReader.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;AACjB","sourcesContent":["#pdfReader{\n    margin-top: 0px;\n    height: calc(100% - 20px);\n    width: 100vw;\n}\n.pdfViewer{\n    height: 100%;\n}\n.pdfViewer--hidden{\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
